import type { ReactNode } from 'react'

import { Check, X } from 'lucide-react'

import type { PaymentConfirmationVariant } from './payment-confirmation-variants'

interface PaymentConfirmationLayoutProps {
  children: ReactNode
  variant: PaymentConfirmationVariant
}

export function PaymentConfirmationLayout({ children, variant }: PaymentConfirmationLayoutProps) {
  return (
    <div className="min-h-screen w-full bg-gray-light-100">
      <div className="mx-auto flex w-full max-w-188 flex-col items-center px-4 pt-8 pb-10 sm:px-0">
        <img alt="logo" className="h-9" src="/logos/massilia-logo.png" />
        <div
          className={`mt-9 flex h-19.5 w-19.5 items-center justify-center rounded-full ${variant.iconBackgroundClassName}`}
        >
          <StatusIcon type={variant.iconType} />
        </div>
        <div className="mt-16 flex w-full flex-col gap-10">{children}</div>
      </div>
    </div>
  )
}

function StatusIcon({ type }: { type: PaymentConfirmationVariant['iconType'] }) {
  if (type === 'hourglass') {
    return <img alt="hourglass" className="h-11 w-11" src="/icons/hourglass.svg" />
  }

  if (type === 'check') {
    return <Check className="h-11 w-11 text-brand-600" />
  }

  return <X className="h-11 w-11 text-error-600" />
}
